
// const isLocal = window.location.hostname === 'localhost'
//              || window.location.hostname === '127.0.0.1';

// export const BASE_URL = isLocal
//     ? 'http://localhost/CODIZN-full-project%20(2)/codizn/backend'
//     : 'https://auroraluxury.shop/backend';  // ✅ Your production URL

// export const WA_NUMBER  = '919959864301';
// export const STORE_NAME = 'Aurora Luxury India';

// export const imgSrc = (url) => {
//     if (!url) return null;
//     if (url.startsWith('http')) return url;

//     const origin = isLocal
//         ? 'http://localhost'
//         : 'https://auroraluxury.shop';  // ✅ Your production origin

//     try {
//         const decoded = decodeURIComponent(url);
//         return origin + decoded;
//     } catch {
//         return origin + url;
//     }
// };

const isLocal = window.location.hostname === 'localhost'
             || window.location.hostname === '127.0.0.1';

export const BASE_URL = isLocal
    ? 'http://localhost/CODIZN-full-project%20(2)/codizn/backend'
    : 'https://auroraluxury.shop/backend';

export const WA_NUMBER = '919959864301';

export const STORE_NAME = 'Aurora Luxury India';

export const imgSrc = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;

    const origin = isLocal
        ? 'http://localhost'
        : 'https://auroraluxury.shop';

    try {
        const decoded = decodeURIComponent(url);
        return origin + decoded;
    } catch {
        return origin + url;
    }
};